import { useCallback } from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useSelectContextMutation } from 'api/candidate-portal-api';
import { setSelectedContext } from 'api/candidate-portal-slice';

/**
 * Hook for selecting a candidate context in the candidate portal
 * @returns {Object} Object containing handleSelectCandidate function and isLoading state
 */
export const useSelectCandidateContext = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectContext, { isLoading }] = useSelectContextMutation();

  const handleSelectCandidate = useCallback(
    async candidate => {
      try {
        const result = await selectContext({
          candidateId: candidate.candidate_id,
        }).unwrap();

        // company_id comes from the response (derived from candidate)
        dispatch(
          setSelectedContext({
            candidateId: result.candidate_id,
            companyId: result.company_id,
          }),
        );

        navigate(`/portal/dashboard/${result.candidate_id}`);
      } catch (error) {
        console.error('Failed to select context:', error);
      }
    },
    [selectContext, dispatch, navigate],
  );

  return {
    handleSelectCandidate,
    isLoading,
  };
};
